import { useServices } from "@/services-context";
import { PaymentTermsDesktop } from "./payment-terms-desktop";
import { PaymentTermsMobile } from "./payment-terms-mobile";
import { LocationHook, RouteHook, useLocation, useRoute } from "preact-iso";
import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import { Services } from "@/services/services";
import { pageSuspense, useSuspenseLoader } from "@/helpers/suspense";
import { StaticPagesType } from "@/context/static-pages";
import { PageTags } from "@/elements-react/document-elements/page-tags.tsx";
import { SeoMarkupDataset } from "@/services/seo-markup.ts";
import { Url } from "@/helpers/url.ts";

const fetchPageData = async (params: { services: Services; location: LocationHook; route: RouteHook }) => {
  const { services, location, route } = params;

  await services.initialize.prepare({
    location: location,
    route: route,
  });

  const registryUrl = Url.normalizeRoute(route.path);
  const alternates = await services.routes.resolveAlternates(registryUrl);

  if (!services.staticPages.has(StaticPagesType.paymentTerms)) {
    await services.staticPages.fetchStaticPage(StaticPagesType.paymentTerms);
  }

  return {
    type: "static",
    canonical: registryUrl,
    alternates: alternates,
  };
};

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return PaymentTermsDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return PaymentTermsMobile;
  }
};

export const PaymentTermsPage = pageSuspense(() => {
  const route = useRoute();
  const location = useLocation();
  const services = useServices();
  const { layoutType } = useLayoutType();

  const seoMarkupDataset = useSuspenseLoader({
    key: "payment-terms-route",
    loader: () =>
      fetchPageData({
        services: services,
        location: location,
        route: route,
      }),
  }) as SeoMarkupDataset;

  const content = services.staticPages.getStaticPage(StaticPagesType.paymentTerms);
  const PageComponent = getPageComponent(layoutType);

  return (
    <div style={{ display: "contents" }}>
      <PageComponent content={content} />
      <PageTags seo={seoMarkupDataset} />
    </div>
  );
});
